module.exports = __webpack_public_path__ + "static/img/MS04.f2f0d9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/MS04.jpg
// module id = v6Mw
// module chunks = 9